import './about.css'
import Container from 'react-bootstrap/Container'
import Footer from './Footer'
import Image from 'react-bootstrap/Image'
import AboutUs1 from "../images/aboutUs1.jpeg"


export default function About() {
    return(
        <div>
            <Image src={AboutUs1} id="amaranth"></Image>
            <h1 id="about-header">About Us</h1>
            <Container>
                <h5>
                    Our Journey: Growing to Nourish Tucson
                </h5>
                <p>
                    Holistic Green Things was founded on a firm devotion to real, whole food. To us, real food means 
                    something pure—it is not heavily processed, genetically modified, grown with harmful pesticides, 
                    or raised in depleted, nutrient-stripped soil. Sadly, today’s commercial farming and food industry 
                    have made these compromises the norm. When we saw the extent of these challenges, we asked ourselves: 
                    What can we do to make a true change? 
                    We found our answer in small-scale, local urban farming.
                </p>
                <h5>
                    How We’ve Expanded Over the Years
                </h5>
                <p>
                    What began as a passionate focus on cultivating clean, zero-soil-contact microgreens has grown into 
                    something much larger. We realized that true holistic health requires an entire ecosystem of real food 
                    choices. To meet that mission, we have intentionally expanded over the years—introducing gourmet
                     mushrooms grown right on our urban farm, small-batch fresh pasta, house-made vegan butter, and artisan 
                     breads baked fresh in our farm kitchen. We even grew to include wheatgrass so your pets can enjoy clean 
                     whole food too!
                </p>
                <h5>
                    Our Ongoing Goals
                </h5>
                <p>
                    Our goal has always been simple: to bridge the gap between our neighbors and honest, transparent 
                    agriculture. We know how vital it is to eat healthy food, and we want to make it as effortless as 
                    possible for you to do the same. By building out convenient home delivery routes across the Tucson 
                    metro area and setting up pre-orders for local farmers markets, we bring the farm straight to your table.
                    Supporting Holistic Green Things isn't just promoting a local business—it’s championing a local food 
                    movement. We look forward to sharing our growing urban farm kitchen with you!
                </p>

            </Container>

          
        </div>
    )
}